import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  UpdateAutomationRuleMatchParams,
  updateAutomationRuleRouteProps,
} from 'src/navigation/routeProps'
import {
  selectCalculatedBackgroundLocation,
  selectLocationFromState,
} from 'src/redux/selectors/router.selectors'

export const selectOrgIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<UpdateAutomationRuleMatchParams>(
      backgroundLocation.pathname,
      updateAutomationRuleRouteProps,
    ) as match<UpdateAutomationRuleMatchParams>
    return mtch?.params.orgId
  },
)

export const selectAutomationRuleIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<UpdateAutomationRuleMatchParams>(
      location.pathname,
      updateAutomationRuleRouteProps,
    ) as match<UpdateAutomationRuleMatchParams>
    return mtch?.params.ruleId
  },
)
